/* ui/tournament/Configuration.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	to_number,
	transition_in,
	transition_out
} from "svelte/internal";

import { defaultConfig, configurationStore } from "./tournament_store";
import AIDropdown from "../game/configuration/AIDropdown.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-1pflrg2-style";
	style.textContent = ".container.svelte-1pflrg2{display:grid;grid-template-columns:1fr 1fr;grid-gap:5px}label.svelte-1pflrg2{grid-column:1;white-space:nowrap}input.svelte-1pflrg2{grid-column-start:2;width:4em;font-size:.7em}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let aidropdown;
	let t0;
	let div;
	let label;
	let t2;
	let input;
	let current;
	let mounted;
	let dispose;
	aidropdown = new AIDropdown({});

	return {
		c() {
			create_component(aidropdown.$$.fragment);
			t0 = space();
			div = element("div");
			label = element("label");
			label.textContent = "Number of Matches";
			t2 = space();
			input = element("input");
			attr(label, "class", "svelte-1pflrg2");
			attr(input, "type", "number");
			attr(input, "min", "1");
			attr(input, "max", "1000");
			attr(input, "class", "svelte-1pflrg2");
			attr(div, "class", "container svelte-1pflrg2");
		},
		m(target, anchor) {
			mount_component(aidropdown, target, anchor);
			insert(target, t0, anchor);
			insert(target, div, anchor);
			append(div, label);
			append(div, t2);
			append(div, input);
			set_input_value(input, /*matches*/ ctx[0]);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[2]),
					listen(input, "change", /*reset*/ ctx[1])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*matches*/ 1 && to_number(input.value) !== /*matches*/ ctx[0]) {
				set_input_value(input, /*matches*/ ctx[0]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(aidropdown.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(aidropdown.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(aidropdown, detaching);
			if (detaching) detach(t0);
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { matches } = defaultConfig.tournament;

	function reset() {
		const tournament = { matches };
		configurationStore.update(configuration => ({ ...configuration, tournament }));
	}

	function input_input_handler() {
		matches = to_number(this.value);
		$$invalidate(0, matches);
	}

	return [matches, reset, input_input_handler];
}

class Configuration extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1pflrg2-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Configuration;